module.exports = __webpack_public_path__ + "static/media/gates.0e4aebd5.PNG";